import { useaxios } from "../../../../utils/useaxios";
export default (company_name, invoiceno, from, to) => reportDispatch => {
    var today = new Date();
    today = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
    useaxios('radio_income/income_report.php', { company_name, invoiceno, from, to }).then((res) => {
        console.log(res);
        if (res.status == "ok") {
            reportDispatch({ type: 'setincomereport', payload: res.data });
        } else {
            // clear();
        }
    });
}